import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import { useScrollSize } from '../../../../../utils/hooks/useScrollSize.js';
import styles from './index.module.scss.js';

const Item = ({
  itemMaxWidth,
  itemMaxHeight,
  className,
  style,
  duration,
  isInitiallyVisible,
  children,
  gap,
  direction,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(isInitiallyVisible);
  const ref = useRef(null);
  const { scrollHeight, scrollWidth } = useScrollSize(ref);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true);
    }, 10);
    return function() {
      clearTimeout(timeout);
    };
  }, []);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      className: cx(styles.box, className, {
        [styles.active]: isVisible,
        [styles[direction]]: !!direction
      }),
      "data-live-item": true,
      style: {
        ...style,
        "--duration": `${duration / 1e3}s`,
        "--height": `${itemMaxHeight || scrollHeight}px`,
        "--width": `${itemMaxWidth || scrollWidth}px`,
        "--gap": `${gap}px`
      },
      ref
    },
    children
  );
};

export { Item };
//# sourceMappingURL=index.js.map
